export default "__VITE_ASSET__IBLjEBgs__"